export default [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['./vue/login.vue'], resolve)
    }
]


// WEBPACK FOOTER //
// ./src/components/login/index.js